import React from "react";
import {IconButton} from "../core/IconButton.jsx";

export function Dialog({open=false,title,description,footer,width=520,onClose,children,style,...rest}){
  if(!open) return null;
  return (
    <div role="presentation" onClick={onClose}
      style={{position:"fixed",inset:0,zIndex:60,display:"flex",alignItems:"center",justifyContent:"center",padding:"24px",
        background:"rgba(6,26,27,.42)",backdropFilter:"blur(3px)"}}>
      <div role="dialog" aria-modal="true" onClick={e=>e.stopPropagation()}
        style={{width:"100%",maxWidth:width,background:"var(--surface-card)",borderRadius:"var(--radius-overlay)",
          border:"var(--border-hairline)",boxShadow:"var(--shadow-overlay)",overflow:"hidden",...style}} {...rest}>
        <div style={{display:"flex",alignItems:"flex-start",gap:"16px",padding:"20px 20px 0"}}>
          <div style={{flex:1}}>
            <h4 style={{fontFamily:"var(--font-display)",fontSize:"var(--text-lg)",fontWeight:"var(--weight-bold)",letterSpacing:"var(--tracking-heading)",margin:0}}>{title}</h4>
            {description&&<p style={{margin:"6px 0 0",fontSize:"var(--text-sm)",color:"var(--fg-2)"}}>{description}</p>}
          </div>
          {onClose&&<IconButton icon="x" label="Cerrar" size="sm" onClick={onClose}/>}
        </div>
        {children&&<div style={{padding:"20px"}}>{children}</div>}
        {footer&&<div style={{display:"flex",justifyContent:"flex-end",gap:"8px",padding:"16px 20px",borderTop:"var(--border-hairline)",background:"var(--surface-sunken)"}}>{footer}</div>}
      </div>
    </div>
  );
}
